var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "course insicht insicht--fade-up" }, [
    _c(
      "div",
      { staticClass: "course__list" },
      [
        _c("h2", {
          staticClass: "course__title",
          domProps: {
            innerHTML: _vm._s(_vm.$t("course.title." + _vm.courseType))
          }
        }),
        _vm._v(" "),
        _vm._l(_vm.enhancedCourseDates, function(location) {
          return _c(
            "div",
            {
              key: "courses-" + location.brand + "-" + location.location,
              staticClass: "course__row"
            },
            [
              _c("h3", {
                staticClass: "course__row-title",
                domProps: {
                  innerHTML: _vm._s(
                    location.location +
                      ", " +
                      _vm.$t("brands." + location.brand)
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "course__row-items" },
                _vm._l(location.courses, function(course) {
                  return _c(
                    "div",
                    { key: course.id, staticClass: "course__item" },
                    [
                      _c("input", {
                        staticClass: "course__item-input",
                        attrs: {
                          type: "radio",
                          name: "courseId",
                          id: "course-" + course.id,
                          disabled: _vm.loading
                        },
                        domProps: {
                          checked: course.id == _vm.form.courseId,
                          value: course.id
                        },
                        on: {
                          change: function($event) {
                            return _vm.onSelectDate(course)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "course__item-label",
                          attrs: { for: "course-" + course.id }
                        },
                        [
                          _c("span", {
                            staticClass: "course__item-date",
                            domProps: {
                              innerHTML: _vm._s(_vm.formatDate(course.date))
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "course__item-time",
                            domProps: {
                              innerHTML: _vm._s(_vm.formatTime(course))
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "course__item-lang",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("course.language." + course.locale)
                              )
                            }
                          }),
                          _vm._v(" "),
                          !_vm.isEvent
                            ? _c("span", {
                                staticClass: "course__item-free",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("course.freePlaces", course)
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          course.price
                            ? _c("span", {
                                staticClass: "course__item-price",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.fwgpricecent(
                                      course.price,
                                      "html"
                                    )
                                  )
                                }
                              })
                            : _c("span", {
                                staticClass: "course__item-price",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("course.free"))
                                }
                              })
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        }),
        _vm._v(" "),
        !_vm.enhancedCourseDates.length
          ? _c("div", { staticClass: "course__row" }, [
              !_vm.isEvent
                ? _c("h3", {
                    staticClass: "course__row-title",
                    domProps: { innerHTML: _vm._s(_vm.$t("course.noDates")) }
                  })
                : _c("h3", {
                    staticClass: "course__row-title",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("course.noDatesEvent"))
                    }
                  })
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.form.courseId
      ? _c(
          "div",
          { staticClass: "checkout-form__container" },
          [
            _c("h2", {
              staticClass: "course__title",
              domProps: { innerHTML: _vm._s(_vm.$t("course.formTitle")) }
            }),
            _vm._v(" "),
            _vm.response.message
              ? _c("GeneralMessage", {
                  ref: "message",
                  attrs: {
                    message: _vm.response.message,
                    type: _vm.response.type,
                    stick: ""
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ValidationObserver", {
              ref: "form",
              staticClass: "checkout-form__form-wrapper",
              attrs: { tag: "form", novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var invalid = ref.invalid
                      var errors = ref.errors
                      return [
                        _c(
                          "div",
                          { staticClass: "input-row" },
                          [
                            _c("FormInputSelect", {
                              attrs: {
                                options: _vm.participants,
                                label: _vm.$t("course.participantsLabel"),
                                disabled: _vm.loading
                              },
                              model: {
                                value: _vm.form.participants,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "participants", $$v)
                                },
                                expression: "form.participants"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ValidationObserver", {
                          ref: "address",
                          attrs: { tag: "section", vid: "address" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var invalid = ref.invalid
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "firstname",
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        name: "firstname",
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.firstName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "firstName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.firstName"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "lastname",
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        name: "lastname",
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.lastName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "lastName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.lastName"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("FormInput", {
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "forms.labels.company"
                                            ),
                                            label: _vm.$t(
                                              "forms.labels.company"
                                            ),
                                            labelOption: _vm.$t(
                                              "forms.labels.optional"
                                            ),
                                            name: "company",
                                            required: false,
                                            disabled: _vm.loading
                                          },
                                          model: {
                                            value: _vm.form.company,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "company", $$v)
                                            },
                                            expression: "form.company"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("ValidationObserver", {
                                          staticClass: "input-row__wrapper",
                                          attrs: { tag: "div" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var validated = ref.validated
                                                  var invalid = ref.invalid
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group"
                                                      },
                                                      [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "input-group__span-9",
                                                            attrs: {
                                                              name: "street",
                                                              rules: "required",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.fieldEmpty"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    var invalid =
                                                                      ref.invalid
                                                                    return [
                                                                      _c(
                                                                        "FormInput",
                                                                        {
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            placeholder: _vm.$t(
                                                                              "forms.labels.street"
                                                                            ),
                                                                            label: _vm.$t(
                                                                              "forms.labels.street"
                                                                            ),
                                                                            name:
                                                                              "street",
                                                                            error:
                                                                              errors.length >
                                                                              0,
                                                                            disabled:
                                                                              _vm.loading,
                                                                            required:
                                                                              ""
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .street,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "street",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "form.street"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "input-group__span-3",
                                                            attrs: {
                                                              name:
                                                                "streetNumber",
                                                              rules: "required",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.fieldEmpty"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    var invalid =
                                                                      ref.invalid
                                                                    return [
                                                                      _c(
                                                                        "FormInput",
                                                                        {
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            placeholder: _vm.$t(
                                                                              "forms.labels.number"
                                                                            ),
                                                                            label: _vm.$t(
                                                                              "forms.labels.number"
                                                                            ),
                                                                            name:
                                                                              "number",
                                                                            error:
                                                                              errors.length >
                                                                              0,
                                                                            disabled:
                                                                              _vm.loading,
                                                                            required:
                                                                              ""
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .streetNumber,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "streetNumber",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "form.streetNumber"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("div", {
                                                          staticClass:
                                                            "input-error input-group__span-12",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              Object.values(
                                                                errors
                                                              )
                                                                .filter(
                                                                  function(
                                                                    value
                                                                  ) {
                                                                    return !!value
                                                                      .join("")
                                                                      .trim()
                                                                  }
                                                                )
                                                                .join(" ")
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("ValidationObserver", {
                                          ref: "zipCity",
                                          staticClass: "input-row__wrapper",
                                          attrs: { tag: "div" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var dirty = ref.dirty
                                                  var validated = ref.validated
                                                  var invalid = ref.invalid
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group"
                                                      },
                                                      [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "input-group__span-4 input-group__span-xxl-3",
                                                            attrs: {
                                                              name: "zip",
                                                              rules:
                                                                "required|digits:4",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.fieldEmpty"
                                                                ),
                                                                digits: _vm.$t(
                                                                  "forms.errors.zip"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    var invalid =
                                                                      ref.invalid
                                                                    return [
                                                                      _c(
                                                                        "FormInput",
                                                                        {
                                                                          ref:
                                                                            "courseZip",
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            placeholder: _vm.$t(
                                                                              "forms.labels.zip"
                                                                            ),
                                                                            label: _vm.$t(
                                                                              "forms.labels.zip"
                                                                            ),
                                                                            name:
                                                                              "zip",
                                                                            minlength: 4,
                                                                            maxlength: 4,
                                                                            inputmode:
                                                                              "decimal",
                                                                            pattern:
                                                                              "[0-9]{4}",
                                                                            error:
                                                                              errors.length >
                                                                              0,
                                                                            disabled:
                                                                              _vm.loading,
                                                                            required:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            keydown:
                                                                              _vm.onZipKeydown,
                                                                            input:
                                                                              _vm.onZipInput
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .postcode,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "postcode",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "form.postcode"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "input-group__span-8 input-group__span-xxl-9",
                                                            attrs: {
                                                              name: "city",
                                                              rules: "required",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.fieldEmpty"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    var invalid =
                                                                      ref.invalid
                                                                    return [
                                                                      _c(
                                                                        "FormInput",
                                                                        {
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            placeholder: _vm.$t(
                                                                              "forms.labels.city"
                                                                            ),
                                                                            label: _vm.$t(
                                                                              "forms.labels.city"
                                                                            ),
                                                                            name:
                                                                              "city",
                                                                            error:
                                                                              errors.length >
                                                                              0,
                                                                            disabled:
                                                                              _vm.loading,
                                                                            required:
                                                                              ""
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .city,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "city",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "form.city"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    invalid &&
                                                    (validated || dirty)
                                                      ? _c("div", {
                                                          staticClass:
                                                            "input-error input-group__span-12",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              Object.values(
                                                                errors
                                                              )
                                                                .filter(
                                                                  function(
                                                                    value
                                                                  ) {
                                                                    return !!value
                                                                      .join("")
                                                                      .trim()
                                                                  }
                                                                )
                                                                .join(" ")
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "phone",
                                            rules: "required|phone",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              ),
                                              phone: _vm.$t(
                                                "forms.errors.phone"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "tel",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.phone"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.phone"
                                                        ),
                                                        name: "phone",
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.phoneNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "phoneNumber",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.phoneNumber"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "additional-info",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "course.phoneHint"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "email",
                                            rules: "required|email",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              ),
                                              email: _vm.$t(
                                                "forms.errors.emailInvalid"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "email",
                                                        name: "email",
                                                        autocomplete: "email",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value: _vm.form.email,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "form.email"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "additional-info",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "course.emailHint"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-row" }, [
                          _c(
                            "div",
                            { staticClass: "input-row__wrapper" },
                            [
                              _c("FormInputTextarea", {
                                attrs: {
                                  placeholder: _vm.$t("forms.labels.notes"),
                                  label: _vm.$t("forms.labels.notes"),
                                  labelOption: _vm.$t("forms.labels.optional"),
                                  disabled: _vm.loading
                                },
                                model: {
                                  value: _vm.form.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notes", $$v)
                                  },
                                  expression: "form.notes"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.form.participants > 1
                          ? [
                              _c("h3", {
                                staticClass: "course__subtitle",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("course.participantsTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.form.participants - 1, function(
                                participant
                              ) {
                                return [
                                  _c("label", {
                                    staticClass: "input-row-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("course.participantRowLabel", {
                                          number: participant
                                        })
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "input-row" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "input-row__wrapper",
                                        attrs: {
                                          name: "firstname-" + participant,
                                          rules: "required",
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t(
                                              "forms.errors.fieldEmpty"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                var invalid = ref.invalid
                                                var validated = ref.validated
                                                return [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "forms.labels.firstname"
                                                      ),
                                                      label: _vm.$t(
                                                        "forms.labels.firstname"
                                                      ),
                                                      name: "firstname",
                                                      error: errors.length > 0,
                                                      disabled: _vm.loading,
                                                      required: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .participantFirstNames[
                                                          participant - 1
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.participantFirstNames,
                                                          participant - 1,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "participantFirstNames[participant - 1]"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  invalid && validated
                                                    ? _c("span", {
                                                        staticClass:
                                                          "input-error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            errors[0]
                                                          )
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("ValidationProvider", {
                                        staticClass: "input-row__wrapper",
                                        attrs: {
                                          name: "lastname-" + participant,
                                          rules: "required",
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t(
                                              "forms.errors.fieldEmpty"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                var invalid = ref.invalid
                                                var validated = ref.validated
                                                return [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "forms.labels.lastname"
                                                      ),
                                                      label: _vm.$t(
                                                        "forms.labels.lastname"
                                                      ),
                                                      name: "lastname",
                                                      error: errors.length > 0,
                                                      disabled: _vm.loading,
                                                      required: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .participantLastNames[
                                                          participant - 1
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.participantLastNames,
                                                          participant - 1,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "participantLastNames[participant - 1]"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  invalid && validated
                                                    ? _c("span", {
                                                        staticClass:
                                                          "input-error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            errors[0]
                                                          )
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              })
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("FormInput", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          ref: "captcha",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("forms.labels.addressDetails"),
                            label: _vm.$t("forms.labels.addressDetails"),
                            name: _vm.captcha.id,
                            id: _vm.captcha.id,
                            required: ""
                          },
                          model: {
                            value: _vm.captcha.value,
                            callback: function($$v) {
                              _vm.$set(_vm.captcha, "value", $$v)
                            },
                            expression: "captcha.value"
                          }
                        }),
                        _vm._v(" "),
                        _vm.courseTermsPage
                          ? _c("ValidationProvider", {
                              attrs: {
                                rules: { required: { allowFalse: false } },
                                name: "checkTerms",
                                tag: "div",
                                customMessages: {
                                  required: _vm.$t(
                                    "course.errorCancellationTerms"
                                  )
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      var errors = ref.errors
                                      var validated = ref.validated
                                      return [
                                        _c(
                                          "FormInputCheckbox",
                                          {
                                            attrs: {
                                              name: "terms",
                                              value: "checkTerms",
                                              required: "",
                                              immediate: ""
                                            },
                                            model: {
                                              value: _vm.form.checkTerms,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "checkTerms",
                                                  $$v
                                                )
                                              },
                                              expression: "form.checkTerms"
                                            }
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "course.cancellationTermsLabel",
                                                    { url: _vm.courseTermsPage }
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        invalid && validated
                                          ? _c("span", {
                                              staticClass: "input-error",
                                              domProps: {
                                                innerHTML: _vm._s(errors[0])
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: {
                            type: "submit",
                            level: "primary",
                            text: _vm.$t("course.submitButton"),
                            disabled: _vm.loading
                          }
                        })
                      ]
                    }
                  }
                ],
                null,
                false,
                3233268310
              )
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }